import { IUserMilestone } from '../../IUserMilestone';

export const SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED =
  'SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED' as IUserMilestone.RetailerMilestone;
